__turbopack_context__.v({
  "reply-time-text": "index-module-scss-module__jLQsCq__reply-time-text",
});
